import React from "react";
import * as Sentry from "@sentry/nextjs";
import { notification } from "antd";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    // log error messages to sentry here
    Sentry.captureException(error);
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      notification["error"]({
        message: "Something went wrong",
        description: "Pls try later",
      });

      return (
        <div className="mx-auto w-full flex flex-col justify-self-center items-center">
          <h2>Something went wrong.</h2>
          <details style={{ whiteSpace: "pre-wrap" }}>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}

export default ErrorBoundary;
